// src/components/resources/tools/generators/AdMockup/Field.tsx
'use client'

import { clsx } from 'clsx'

/**
 * Labelled field wrapper. When `htmlFor` is supplied the heading is a real
 * `<label htmlFor>` programmatically bound to the control (text/select/number
 * inputs). For fields whose control carries its own `<label>` (file uploads,
 * the verified checkbox) `htmlFor` is omitted and the heading renders as a
 * `<span>` so we never emit an orphan or nested label.
 */
export function Field({ label, htmlFor, full, hint, children }: { label: string; htmlFor?: string; full?: boolean; hint?: string; children: React.ReactNode }): JSX.Element {
  const headingClass = 'block text-sm font-medium text-slate-700 dark:text-slate-200'
  return (
    <div className={clsx('space-y-1.5', full && 'sm:col-span-2')}>
      {htmlFor ? (
        <label htmlFor={htmlFor} className={headingClass}>{label}</label>
      ) : (
        <span className={headingClass}>{label}</span>
      )}
      {children}
      {hint ? <p className="text-xs text-slate-400 dark:text-slate-500">{hint}</p> : null}
    </div>
  )
}
